import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import NostalgiaChange from "@/pages/nostalgie/components/NostalgiaChange";
import PressArchive from "@/pages/nostalgie/components/PressArchive";
import { nostalgiaCollage as collage } from "@/pages/nostalgie/data/nostalgiaPhotos";
import { LocalizedLink } from "@/i18n/language";
import { img } from "@/lib/images";

const headerImg = img("about/header-about-01.jpg");

const facts = [1, 2, 3];

export default function NostalgiaPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("nost_eyebrow")}
          title={t("nost_title")}
          subtitle={t("nost_subtitle")}
          image={headerImg}
          imageAlt="Bali VW Tour – Nostalgie – Erinnerungen an die Anfänge in Mengwi"
        />

        {/* Einführung */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
            <div className="lg:col-span-6">
              <div className="eyebrow-brand text-xs uppercase tracking-[0.35em] mb-3">
                — {t("nost_intro_eyebrow")} —
              </div>
              <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.1] tracking-tight mb-6">
                {t("nost_intro_title")}
              </h2>
              <p className="text-foreground-700 leading-relaxed text-base md:text-lg">
                {t("nost_intro_p1")}
              </p>
              <p className="mt-4 text-foreground-700 leading-relaxed text-base md:text-lg">
                {t("nost_intro_p2")}
              </p>

              <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
                {facts.map((n) => (
                  <div
                    key={n}
                    className="bg-background-50 border border-background-200 rounded-lg px-4 py-4"
                  >
                    <div className="font-heading text-lg text-accent-700 leading-tight mb-1">
                      {t(`nost_fact_${n}_value`)}
                    </div>
                    <div className="text-xs text-foreground-600 leading-snug">
                      {t(`nost_fact_${n}_label`)}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-6">
              <div className="grid grid-cols-2 gap-3 md:gap-4">
                {collage.map((photo) => (
                  <div
                    key={photo.src}
                    className="rounded-lg overflow-hidden aspect-[4/5] group bg-background-200"
                  >
                    <img
                      src={photo.src}
                      alt={photo.alt}
                      title={photo.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <PressArchive />

        <NostalgiaChange />

        {/* Abschluss / CTA */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.1] tracking-tight mb-6">
              {t("nost_cta_title")}
            </h2>
            <p className="text-foreground-700 leading-relaxed text-base md:text-lg mb-10">
              {t("nost_cta_text")}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <LocalizedLink
                to="/about"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-md font-semibold uppercase tracking-wider whitespace-nowrap cursor-pointer transition-colors text-sm"
              >
                {t("nost_cta_about")}
                <i className="ri-arrow-right-line"></i>
              </LocalizedLink>
              <LocalizedLink
                to="/contact"
                className="inline-flex items-center gap-2 border border-foreground-300 hover:border-foreground-500 text-foreground-800 px-8 py-3.5 rounded-md font-semibold uppercase tracking-wider whitespace-nowrap cursor-pointer transition-colors text-sm"
              >
                {t("nost_cta_contact")}
                <i className="ri-mail-line"></i>
              </LocalizedLink>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}